(function () {
    'use strict';

    angular.module('finansApp.courseService', []).factory('courseService', courseService);
    

    function State() {
        this.courses = [];
        this.coursesFiltered = [];
        this.filters = {};
        this.sortOrder = null;
        this.loading = false;
        this.tableview = false;
    }

    courseService.$inject = ['$resource', '$q', 'apiUrl', '$location'];

    function courseService($resource, $q, apiUrl, $location) {
        var state = new State();

        var resource = $resource(apiUrl + "CourseListApi/:methodName/", {}, {
            getCourses: { method: 'GET', params: { methodName: 'GetCourses'}, isArray: false, cache: true }
        });

        // Public
        var service = {
            state: state,
            getCourses: getCourses
        };

        function init() {
        }

        init();

        function getCourses() {

            var deferred = $q.defer(); 

            state.loading = true;

            // Get from API
            resource.getCourses().$promise.then(function(response) {

                state.loading = false;
                deferred.resolve(response);

            }, function() { 
                state.loading = false;
                deferred.reject();
            });

            
            return deferred.promise;
        }
        



        
        return service;



    }

})();

